import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import {
  characterLimits,
  validateCharacterLimit,
  validateHexcode,
  validateUrl,
  handleValidation,
  validateBannerImage,
} from 'utils/admin-forms';
import { AdminInput, AdminFormRow, AdminImageUpload } from 'shared-components';

const CampaignBannerForm = ({
  register,
  errors,
  formDisabled,
  setError,
  clearErrors,
  setBannerDesktopUrl,
  bannerDesktopImageUrl,
  isShopCampaign,
}) => {
  return (
    <>
      <h4>Campaign Banner Design</h4>
      <AdminFormRow>
        <AdminInput
          label="Banner Title"
          type="text"
          name="bannerTitle"
          propRef={register}
          characterLimit={characterLimits.XSMALL}
          disabled={formDisabled}
          onChange={(e) => {
            handleValidation(e, setError, clearErrors, validateCharacterLimit);
          }}
          error={get(errors, ['bannerTitle', 'message'])}
        />
        {isShopCampaign && (
          <AdminInput
            label="Banner Subtitle"
            style={{ width: '588px' }}
            type="text"
            name="bannerSubtitle"
            propRef={register}
            characterLimit={characterLimits.XSMALL}
            disabled={formDisabled}
            onChange={(e) => {
              handleValidation(
                e,
                setError,
                clearErrors,
                validateCharacterLimit
              );
            }}
            error={get(errors, ['bannerSubtitle', 'message'])}
          />
        )}
        {!isShopCampaign && (
          <AdminInput
            label="FAQ Link"
            type="text"
            style={{ width: '588px' }}
            name="bannerFAQUrl"
            propRef={register}
            characterLimit={256}
            disabled={formDisabled}
            onChange={(e) => {
              handleValidation(
                e,
                setError,
                clearErrors,
                validateCharacterLimit,
                validateUrl
              );
            }}
            error={get(errors, ['bannerFAQUrl', 'message'])}
          />
        )}
      </AdminFormRow>
      <AdminFormRow>
        <AdminInput
          label={
            isShopCampaign ? 'Body Text (HTML supported)' : 'Disclaimer Text'
          }
          type="textArea"
          style={{ width: '894px' }}
          name="bannerParagraph"
          propRef={register({
            maxLength: 500,
          })}
          characterLimit={501}
          placeholder={
            isShopCampaign
              ? ''
              : '*All products in your cart will be automatically billed on [enter date], no checkout required!'
          }
          disabled={formDisabled}
          onChange={(e) => {
            handleValidation(e, setError, clearErrors, validateCharacterLimit);
          }}
          error={get(errors, ['bannerParagraph', 'message'])}
        />
      </AdminFormRow>
      <AdminFormRow>
        <AdminImageUpload
          uploadText="Upload Desktop Image"
          labelText="Desktop Background Image"
          tooltip="<div>Guidelines For Uploading Images</div>
          <span>Images must be in PNG, GIF or JPEG format.</span>
          <span>File size must be 500KB or less.</span>
          <span>Image must be at least 2,880 x 800.</span>"
          style={{
            height: '100px',
            width: '360px',
          }}
          name="bannerDesktopImageUrl"
          updateImageUrl={setBannerDesktopUrl}
          imageUrl={bannerDesktopImageUrl}
          validateImage={validateBannerImage}
          disabled={formDisabled}
          imageType="banner"
          error={get(errors, ['bannerDesktopImageUrl', 'message'])}
        />
        <AdminInput
          label="Background Color Hex Code"
          type="text"
          style={{ width: '181px' }}
          name="bannerBackgroundColor"
          onChange={(e) => {
            handleValidation(
              e,
              setError,
              clearErrors,
              validateHexcode,
              validateCharacterLimit
            );
          }}
          characterLimit={characterLimits.HEXCODE}
          disabled={formDisabled}
          error={get(errors, ['bannerBackgroundColor', 'message'])}
          propRef={register}
        />
      </AdminFormRow>
    </>
  );
};

CampaignBannerForm.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.shape({}).isRequired,
  formDisabled: PropTypes.bool,
  setError: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  setBannerDesktopUrl: PropTypes.func.isRequired,
  bannerDesktopImageUrl: PropTypes.string,
  isShopCampaign: PropTypes.bool.isRequired,
};

CampaignBannerForm.defaultProps = {
  formDisabled: false,
  bannerDesktopImageUrl: '',
};

export default CampaignBannerForm;
